import React from 'react';
import { IBonusToDisplay } from '@core/js/components/main/BonusHistory/types';
import { getRenderCancelButton, GetRenderCancelButtonType } from '@theme/js/components/common/Table/accordionFactory/cells/buttonsRenderers/getRenderCancelButton';
import { getHeaderAmount } from '../../helpers';

export type GetRenderBonusAmountType = { isDesktop: boolean, style: Record<string, string> } & GetRenderCancelButtonType;

export const getRenderBonusAmount = ({
    isDesktop,
    style,
    showCancelBonusPopup,
    translate
}: GetRenderBonusAmountType) => (item: IBonusToDisplay) => {
    const bonusName = item.marketingName || item.templateName;
    const { bonusInstanceCode } = item;

    return (
        <div className={style.detailsWrapper}>
            <span className={style.bonusAmountText}>{getHeaderAmount(item, translate)}</span>
            {isDesktop && item.isCancelButton ?
                <span className={style.buttonContainer}>
                    {getRenderCancelButton({ translate, showCancelBonusPopup, tabIndex: -1 })(bonusName, bonusInstanceCode)}
                </span> : null}
        </div>
    );
};
